module.exports = __webpack_public_path__ + "img/duck2.86c728a5.png";